"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WinningNumberLayout = exports.INITIAL_SCREEN_STATE = exports.IQuickDrawJackpotStatus = exports.IQuickDrawDataType = exports.GET_QUICK_DRAW_CONFIG = exports.GET_LAST_24H_QUICK_DRAW_RESULT = exports.GET_JACKPOT_GAME_RESULTS_GROUP = exports.GET_LATEST_QUICK_DRAW_RESULT = void 0;
const INITIAL_SCREEN_STATE = {
    loading: false,
    errorMessage: null,
    page: {},
    jackpotPage: {},
    quickDrawLatestResult: {},
    quickDrawjackpotResultsGrouped: {},
    quickDrawResult: []
};
exports.INITIAL_SCREEN_STATE = INITIAL_SCREEN_STATE;
var IQuickDrawDataType;
(function (IQuickDrawDataType) {
    IQuickDrawDataType[IQuickDrawDataType["REGULAR"] = 0] = "REGULAR";
    IQuickDrawDataType[IQuickDrawDataType["HOT"] = 1] = "HOT";
    IQuickDrawDataType[IQuickDrawDataType["COLD"] = 2] = "COLD";
    IQuickDrawDataType[IQuickDrawDataType["SPECIAL"] = 3] = "SPECIAL";
    IQuickDrawDataType[IQuickDrawDataType["MULTIPLIER"] = 4] = "MULTIPLIER";
})(IQuickDrawDataType || (exports.IQuickDrawDataType = IQuickDrawDataType = {}));
var IQuickDrawJackpotStatus;
(function (IQuickDrawJackpotStatus) {
    IQuickDrawJackpotStatus[IQuickDrawJackpotStatus["OPEN"] = 0] = "OPEN";
    IQuickDrawJackpotStatus[IQuickDrawJackpotStatus["CLOSED"] = 1] = "CLOSED";
    IQuickDrawJackpotStatus[IQuickDrawJackpotStatus["RESULTS_AVAILABLE"] = 2] = "RESULTS_AVAILABLE";
    IQuickDrawJackpotStatus[IQuickDrawJackpotStatus["PAYABLE"] = 3] = "PAYABLE";
    IQuickDrawJackpotStatus[IQuickDrawJackpotStatus["FUTURE"] = 4] = "FUTURE";
    IQuickDrawJackpotStatus[IQuickDrawJackpotStatus["CANCELLED"] = 5] = "CANCELLED";
    IQuickDrawJackpotStatus[IQuickDrawJackpotStatus["NO_MORE_DRAWS"] = 6] = "NO_MORE_DRAWS";
    IQuickDrawJackpotStatus[IQuickDrawJackpotStatus["INVALID"] = 7] = "INVALID";
})(IQuickDrawJackpotStatus || (exports.IQuickDrawJackpotStatus = IQuickDrawJackpotStatus = {}));
var WinningNumberLayout;
(function (WinningNumberLayout) {
    WinningNumberLayout["SINGLE"] = "SINGLE";
    WinningNumberLayout["MULTIPLE"] = "MULTIPLE";
    WinningNumberLayout["NONE"] = "NONE";
})(WinningNumberLayout || (exports.WinningNumberLayout = WinningNumberLayout = {}));
const GET_LATEST_QUICK_DRAW_RESULT = 'quick-draw/GET_LATEST_QUICK_DRAW_RESULT';
exports.GET_LATEST_QUICK_DRAW_RESULT = GET_LATEST_QUICK_DRAW_RESULT;
const GET_JACKPOT_GAME_RESULTS_GROUP = 'quick-draw/GET_JACKPOT_GAME_RESULTS_GROUP';
exports.GET_JACKPOT_GAME_RESULTS_GROUP = GET_JACKPOT_GAME_RESULTS_GROUP;
const GET_LAST_24H_QUICK_DRAW_RESULT = 'quick-draw/GET_LAST_24H_QUICK_DRAW_RESULT';
exports.GET_LAST_24H_QUICK_DRAW_RESULT = GET_LAST_24H_QUICK_DRAW_RESULT;
const GET_QUICK_DRAW_CONFIG = 'quick-draw/GET_QUICK_DRAW_CONFIG';
exports.GET_QUICK_DRAW_CONFIG = GET_QUICK_DRAW_CONFIG;
//# sourceMappingURL=types.js.map